import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Container from 'gatsby-theme-core/src/components/container';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Ad from '../../components/ad';

const EaLayout = ({ children, homepage, ...props }) => (
  <Layout {...props}>
    <GlobalStyle />
    <Wrapper>
      <Header homepage={homepage} />
      <main>{children}</main>
      <Container css="width: 100%; box-sizing: border-box;">
        <Ad />
      </Container>
      <Footer />
    </Wrapper>
  </Layout>
);

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  main {
    flex-grow: 1;
  }
`;

const GlobalStyle = createGlobalStyle`
  h1, h2, h3, h4, h5 {
    margin: 0;
  }
  address {
    font-style: normal;
  }
  pre {
    font-family: inherit;
  }
`;

export default EaLayout;
